import React, { useEffect, useState, useCallback } from 'react';
import { Document } from '../../Models/Document';
import {
  Typography,
  Grid,
  TextField,
  CircularProgress,
  Box,
} from '@mui/material';
import './DocumentListingStyles.css'; // Import custom styles
import { useParams } from 'react-router-dom';
import { Category } from '../../Models/Category';
import DocumentTable from './DocumentTable';
import Stack from '@mui/material/Stack';
import { useAPIContext } from '../../Context/APIContext';
import { DocumentListingFullPageType } from '../../Models/DocumentListingPageType';

interface DocumentListingFullProps {
  type: DocumentListingFullPageType;
}

export default function DocumentListingFull({type}: DocumentListingFullProps) {
  const { categoryId } = useParams();
  const [filteredDocuments, setFilteredDocuments] = useState<Document[]>([]);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [savedDocuments, setSavedDocuments] = useState<Document[]>([]);
  const [category, setCategory] = useState<Category>();
  const [loading, setLoading] = useState<boolean>(false);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { apiFetch } = useAPIContext();

  const fetchDocumentData = useCallback(async () => {
    setLoading(true);

    let DocumentData;
    let savedDocumentData;

    if (type === DocumentListingFullPageType.Saved) {
        DocumentData = await apiFetch<Document[]>('Users/SavedDocuments', 'GET', Document.fromJsonArray);
        savedDocumentData = DocumentData;
    } else {
      if (!categoryId || !(Number(categoryId) > 0)) {
        setLoading(false);
        return;
      }
      DocumentData = await apiFetch<Document[]>(`Documents?categoryId=${categoryId}&limit=1000`, 'GET', Document.fromJsonArray);
      savedDocumentData = await apiFetch<Document[]>(`Users/SavedDocuments`, 'GET', Document.fromJsonArray);
      const category = await apiFetch<Category>(`Categories/${categoryId}`, 'GET', Category.fromJson);
      if (category) setCategory(category);
    }

    if (DocumentData) {
      setDocuments(DocumentData);
      setFilteredDocuments(DocumentData);
    }
    if (savedDocumentData) {
      setSavedDocuments(savedDocumentData);
    }

    setLoading(false);
  }, [apiFetch, categoryId, type]); // add dependencies here

  useEffect(() => {
    fetchDocumentData();
  }, [fetchDocumentData]);

  useEffect(() => {
    setSearchLoading(true);
    const lowercasedFilter = searchTerm.toLowerCase();
    const filteredData = documents.filter((document) =>
      document.title?.toLowerCase().includes(lowercasedFilter)
    );
    setFilteredDocuments(filteredData);
    setSearchLoading(false);
  }, [searchTerm, documents]);

  return (
    <>
      {loading ? (
        <center>
          <CircularProgress style={{ color: '#3D9BE9' }} />
        </center>
      ) : (
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: { xs: 3, sm: 3, md: 3 },
            pb: 5,
            mt: { xs: 1, md: 0 },
          }}
        >
          <Box sx={{ width: '100%', maxWidth: '1700px', pt: 1 }}>

            <Box className="header-section" mb={2}>

              <Grid container spacing={2} alignItems="center" mb={0}>
                <Grid item xs={12} md>
                  {type === DocumentListingFullPageType.Category ? (
                      <Typography
                          className="header-text"
                          sx={{
                            fontSize: '1.5em',
                          }}
                        >{category?.name}</Typography>
                    ):null}
  
                    {type === DocumentListingFullPageType.Saved ? (
                        <Typography
                          className="header-text"
                          sx={{
                            fontSize: '1.5em',
                          }}
                        >Saved Guides</Typography>
                    ):null}
                </Grid>
                <Grid item>
                  <TextField
                    label="Search Guides"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    size="small"
                    sx={{
                      minWidth: { xs: '200px', sm: '250px', md: '300px' },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>



            {searchLoading ? (
              <center>
                <CircularProgress style={{ color: '#3D9BE9' }} />
              </center>
            ) : filteredDocuments.length > 0 ? (
              <DocumentTable Documents={filteredDocuments} savedDocuments={savedDocuments}/>

              // <DocumentGrid Documents={filteredDocuments} savedDocuments={savedDocuments} categoryId={categoryId ?? ""} />
            ) : (
              <Typography variant="h6" align="center" color="textSecondary" style={{ minHeight: '400px' }}>
                No Guides found.
              </Typography>
            )}
          </Box>
        </Stack>
      )}
    </>
  );
}
